import { create } from 'zustand';
import type { Tone } from '@/components/ui/StatusBadge';

/**
 * Small "status badge next to the page title in the Topbar" slot. A page sets it
 * on mount (e.g. LiveMonitor's live/מתעדכן indicator) and clears it on unmount,
 * so the Topbar can render the badge beside the dynamic page title without the
 * page owning any Topbar markup.
 */
export interface PageBadge {
  label: string;
  tone: Tone;
  /** Show a leading status dot. */
  dot?: boolean;
}

interface PageBadgeState {
  badge: PageBadge | null;
  setBadge: (b: PageBadge | null) => void;
}

export const usePageBadge = create<PageBadgeState>((set) => ({
  badge: null,
  setBadge: (badge) => set({ badge }),
}));
